import _ from '@/setup/lodash';
import { SITE_SETTINGS_FETCH } from './action-types';
import type { SiteSettingsState } from './state';
import type { GetSitesResponse } from '@/types/openapi-ts';

export default {
  [SITE_SETTINGS_FETCH]: (state: SiteSettingsState, data: GetSitesResponse['payload']) => {
    const indexData: Record<string, GetSitesResponse['payload'][number]> = {};
    data.forEach((item) => {
      indexData[item['id']] = item;
    });
    state.data = _.cloneDeep(indexData);
  },
};
